import React from "react";
import { useEvent } from "../../../context/EventContext";

// * Meeting is a component that displays the accepted and rejected meeting invitations.
const Meeting = () => {
  const { acceptedInvitations, rejectedInvitations } = useEvent();
  return (
    <div>
      <div className="message-details">
        {acceptedInvitations.length > 0 ? (
          <>
            <h3>Accepted Invitations</h3>
            {acceptedInvitations.map((invitation, index) => (
              <div key={index} className="accepted-card">
                <p>Meeting Agenda: {invitation.agenda}</p>
                <p>Date: {new Date(invitation.start).toLocaleString()}</p>
              </div>
            ))}
          </>
        ) : (
          <>
            <h3>Rejected Invitations</h3>
            {rejectedInvitations.length === 0 ? (
              <p>No rejected invitations.</p>
            ) : (
              rejectedInvitations.map((invitation, index) => (
                <div key={index} className="rejected-card">
                  <p>Meeting Agenda: {invitation.agenda}</p>
                  <p>Date: {new Date(invitation.start).toLocaleString()}</p>
                </div>
              ))
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Meeting;
